import { Button, Divider, Checkbox, notification } from "antd";
import { CustomModal } from "../common/CustomModal";
import * as React from "react";
import { Layout, Input, Select } from "antd";
import { Formik } from "formik";
import { listAllDropDownCourse } from "../../Graphs/Course/listAllDropDownCourse";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { editAdmin } from "../../Graphs/Admin/editAdmin";
import { listUser } from "../../Graphs/CorporateGroups/listUser";

const { Content } = Layout;
const Option = Select.Option;

export class EditForm extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      data: null,
      view: false,
      isLoading: false,
      visible: false,
      isRestricted: false,
      isPrivate: false,
    };
  }

  input;
  allCourses = [];


  handleSubmit = async (values) => {
    const { Token, itemId, onCancel, item } = this.props;

    // console.log("Item ID: ", item, itemId)
    try {
      if (this.state.selectedUser && this.state.selectedUser._id) {
        // console.log("Updating user:", values);
      } else {
        // console.log("Creating new user:", values);
        const response = await editAdmin(Token, values, itemId);

        if (response && response.success) {
          // console.log("User added successfully:", response.data);
          notification["success"]({
            message: "New Admin Added Successfully",
          });
        } else {
          console.error("Failed to add user:", response);
        }
      }
    } catch (error) {
      console.error("Error in handleSubmit:", error);
    }

    onCancel();
  };


  onChangeIsRestricted() {
    this.setState({
      isRestricted: !this.state.isRestricted,
    });
  }

  onChangeIsPrivate() {
    this.setState({
      isPrivate: !this.state.isPrivate,
    });
  }

  validateForm = (values) => {
    const errors = {};
    if (!values.group_name || !values.group_name.trim()) {
      errors.group_name = "Group name is required";
    }
    if (!values.email) {
      errors.email = "Email is required";
    }
    if (!values.first_name) {
      errors.first_name = "First name is required";
    }
    if (!values.last_name) {
      errors.last_name = "Last name is required";
    }
    return errors;
  };

  isChanged = (values) => {
    const { item } = this.props;
    const safeItem = item || {};

    if (values.group_name !== (safeItem.group_name || safeItem.first_name || "")) return true;
    if (values.first_name !== (safeItem.first_name || "")) return true;
    if (values.last_name !== (safeItem.last_name || "")) return true;
    if (values.email !== (safeItem.email || "")) return true;

    return false;
  };

  render() {
    const { primaryColor, item } = this.props;
    const { data, isLoading } = this.state;
    // const { subAdminType } = this.state;
    // console.log("Item", item)

    const safeItem = item || {};

    return (
      <div>
        <CustomModal
          destroyOnClose={true}
          title="Edit Admin"
          visible={this.props.visible} // Use prop instead of state
          //   onCancel={() => this.setState({ visible: false })}
          onCancel={this.props.onCancel} // Call parent function
          footer={null}
          maskClosable={false}
        >
          <Content style={{ background: "#fff", marginLeft: "10px" }}>
            <Formik
              initialValues={{
                group_name: safeItem.group_name || safeItem.first_name || "",
                first_name: safeItem.first_name || "",
                last_name: safeItem.last_name || "",
                email: safeItem.email || "",
                phone: "",
                password: "",
                confirm_password: "",
                role: "corporate",
                permissions: this.permissionsData,
              }}
              validate={this.validateForm}
              onSubmit={this.handleSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                setFieldTouched,
                isSubmitting,
              }) => {
                return (
                  <div>
                    <div className="formik-field_wrap">
                      <div className="formik-field-left" style={{ width: "100%" }}>
                        Group Name
                        <Input
                          id="group_name"
                          placeholder="Group Name"
                          value={values.group_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.group_name && touched.group_name ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.group_name}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        First Name
                        <Input
                          id="first_name"
                          placeholder="First Name"
                          value={values.first_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.first_name && touched.first_name ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.first_name}
                          </p>
                        ) : null}
                      </div>

                      <div className="formik-field-right">
                        Last Name
                        <Input
                          id="last_name"
                          placeholder="Last Name"
                          value={values.last_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.last_name && touched.last_name ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.last_name}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Email
                        <Input
                          id="email"
                          placeholder="Email"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.email && touched.email ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.email}
                          </p>
                        ) : null}
                      </div>
                    </div>

                    {/* <div className="formik-field_wrap">
                      <div className="formik-field-left">
                        Password
                        <Input
                          type="password"
                          id="password"
                          placeholder="Password"
                          value={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.password && touched.password ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.password}
                          </p>
                        ) : null}
                      </div>

                      <div className="formik-field-right">
                        Confirm Password
                        <Input
                          id="confirm_password"
                          type="password"
                          placeholder="Confirm Password"
                          value={values.confirm_password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.confirm_password && touched.confirm_password ? (
                          <p
                            style={{
                              color: "red",
                              fontSize: "small",
                              margin: "0",
                            }}
                          >
                            {errors.confirm_password}
                          </p>
                        ) : null}
                      </div>
                    </div> */}
                    <Button
                      type="primary"
                      disabled={!this.isChanged(values)}
                      style={{
                        marginTop: "19px",
                        background: this.isChanged(values) ? "#5C6AC4" : "#f5f5f5",
                        color: this.isChanged(values) ? "#fff" : "rgba(0, 0, 0, 0.25)",
                        borderColor: this.isChanged(values) ? "#5C6AC4" : "#d9d9d9",
                      }}
                      onClick={handleSubmit}
                    >
                      Save
                    </Button>
                  </div>
                );
              }}
            </Formik>
          </Content>
        </CustomModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
});

export default connect(mapStateToProps)(withRouter(EditForm));
